<template>
  <a-skeleton v-if="item.loading" active/>
  <div v-else>
    <a-row :gutter="16">
      <a-col :span="20">
        <a-row :gutter="16" style="margin-bottom: 24px;">
          <a-col :span="24">
            <transaction-growth-container :product="product" />
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="24">
            <client-chart-container :product="product" />
          </a-col>
        </a-row>

      </a-col>
      <a-col :span="4">
        <a-card type="inner" size="small" title="Product Details">
          <a-row :gutter="[16,24]">
            <a-col>
              <strong>Price Scheme:</strong>
              <br>
              <code>{{ item.product.price_scheme }}</code>
            </a-col>
            <a-col>
              <strong>Denomination:</strong>
              <br>
              <currency :amount="item.product.denomination" />
            </a-col>
            <a-col>
              <strong>Price:</strong>
              <br>
              <currency :amount="item.product.price" />
            </a-col>
            <a-col>
              <strong>Admin Fee:</strong>
              <br>
              <currency :amount="item.product.admin_fee" />
            </a-col>
            <a-col>
              <strong>Share Fee:</strong>
              <br>
              <currency :amount="item.product.share_fee" />
            </a-col>
            <a-col>
              <strong>Profit Treshold:</strong>
              <br>
              <currency :amount="item.product.profit_threshold" />
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import ClientChartContainer from "./client-chart-container";
import TransactionGrowthContainer from "./transaction-growth-container";
export default {
  name: "product-overview",
  components: {TransactionGrowthContainer, ClientChartContainer},
  props: {
    product: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      item: {
        loading: true,
        product: {}
      }
    }
  },
  mounted() {
    this.getItem()
  },
  methods: {
    getItem() {
      this.$http.get(this.routeUri('hyperion.product.show', {
        product_hash: this.product
      }) + '?q=').then(res => this.item.product = res.data)
        .catch(err => this.handleXhrError(err))
        .finally(() => this.item.loading = false)
    }
  }
}
</script>
